import React from "react";

function formatSize(sizeKb) {
  if (!sizeKb && sizeKb !== 0) return "-";
  if (sizeKb > 1024) return `${(sizeKb / 1024).toFixed(2)} MB`;
  return `${sizeKb} KB`;
}

function FileList({ files = [], onDownload, onRemove, showRemove = false, showDownload = true, downloadLabel = 'Download' }) {
  return (
    <div className="table-responsive">
      <table className="table table-sm align-middle">
        <thead>
          <tr>
            <th style={{ width: "20%" }}>Title</th>
            <th style={{ width: "25%" }}>File Name</th>
            <th style={{ width: "20%" }}>Category</th>
            <th style={{ width: "15%" }}>Size</th>
            <th style={{ width: "20%" }}>Uploaded On</th>
            <th style={{ width: "15%" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {files.length === 0 && (
            <tr>
              <td colSpan={6} className="text-center text-muted">No files</td>
            </tr>
          )}
          {files.map((file) => (
            <tr key={file.key || file.FileLibraryId || file.OriginalName}>
              <td title={file.FileTitle || ''}>{file.FileTitle || '-'}</td>
              <td title={file.OriginalName}>{file.OriginalName}</td>
              <td>{file.FileCategory || file.category || '-'}</td>
              <td>{formatSize(file.FileSizeKB)}</td>
              <td>{file.CreatedDate ? new Date(file.CreatedDate).toLocaleString() : file.status || '-'}</td>
              <td>
                {showDownload && file.FileLibraryId && (
                  <button className="btn btn-sm btn-outline-primary me-2" onClick={() => onDownload && onDownload(file)}>
                    {downloadLabel}
                  </button>
                )}
                {showRemove && (
                  <button className="btn btn-sm btn-outline-danger" onClick={() => onRemove && onRemove(file)}>
                    Remove
                  </button>
                )}
                {!file.FileLibraryId && !showRemove && file.status && (
                  <span className="badge bg-secondary">{file.status}</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default FileList;
